import { createSlice } from "@reduxjs/toolkit";

export const warehouseListSlice = createSlice({
  name: "warehouseList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedWarehouse: null,
    filteredRecords: 0,
    isSingleWarehouseLoading: false,
    isLoading: false,
    isAnswerByTechTeam: false,
    isSingleWarehouseNotFound: false,
  },
  reducers: {
    setAllWarehouseLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleWarehouseLoadingState: (state, action) => {
      state.isSingleWarehouseLoading = true;
    },
    loadAllWarehouse: (state, action) => {
      const listObj = {};
      action.payload.warehouses.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.warehouses.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleWarehouse: (state, action) => {
      state.selectedWarehouse =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleWarehouseLoading = false;
    },
    setSingleWarehouseNotFound: (state, action) => {
      state.isSingleWarehouseNotFound = action.payload;
    },
  },
});

export const {
  setAllWarehouseLoadingState,
  setSingleWarehouseLoadingState,
  loadAllWarehouse,
  loadSingleWarehouse,
  setSingleWarehouseNotFound,
} = warehouseListSlice.actions;

export default warehouseListSlice.reducer;
